@if (teaRegion) {
  @if (errors.length > 0) {
    <div class="m-2">
      <div class="bg-red-500 text-white p-4 rounded">
        <h2 class="text-xl font-bold">Something went wrong:</h2>
        <ul>
          @for (error of errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    </div>
  }
  <div class="m-2">
    <h1 class="text-center text-3xl mt-2 font-bold text-green-900">{{ teaRegion.name }}</h1>
    <div class="pt-5 markdown" [innerHTML]="teaRegion.description | markdown | async">
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 pt-5">
      @for (tea of teas; track tea) {
        <tea-shop-fe-tea-item-summary [teaItem]="tea"></tea-shop-fe-tea-item-summary>
      }
    </div>
  </div>
} @else {
  <div class="m-2">
    <div class="animate-pulse">
      <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/6 mb-2"></div>
    </div>
  </div>
}

